import { useRef } from 'react'

import { Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUpdateAnalyticsConsent } from 'modules/core/hooks/useUpdateAnalyticsConsent'
import { buildWebpageUrl } from 'modules/core/lib/buildUrl'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

class AnalyticsConsentForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      consent: 'boolean',
    })
  }
}

const AnalyticsConsentSetting = () => {
  const {
    access: { id: accessId, analyticsConsent },
  } = useCurrentSession()

  const analyticsConsentForm = useRef(
    new AnalyticsConsentForm({
      consent: analyticsConsent,
    })
  ).current

  const showHelpCenterLink = {
    href: buildWebpageUrl('/product-cookies-policy'),
    label: i18n.t('personal_settings.analytics_consent.learn_more'),
  }
  const { loading: updating, update } = useUpdateAnalyticsConsent({
    onCompleted(data) {
      if (data.apiCoreMutations.updateApicoreAccess.errors.length) {
        return
      }
    },
  })

  async function handleOnToggle(value: boolean | undefined): Promise<unknown> {
    const result = await update({
      id: accessId,
      analyticsConsent: value,
    })

    const handled = handleResult(result, (errors) => {
      console.error(errors) // eslint-disable-line no-console
    })

    if (handled.success) {
      window.location.reload()
    }

    return handled
  }

  return (
    <Section
      illustration="user-interaction-review_chart"
      title={i18n.t('personal_settings.analytics_consent.title')}
      description={i18n.t('personal_settings.analytics_consent.description')}
      link={showHelpCenterLink}
    >
      <Card>
        <Card.Title
          action={
            <TogglerCheckbox
              value={analyticsConsentForm.get('consent').value}
              onChange={handleOnToggle}
              disabled={updating}
            />
          }
        >
          {i18n.t('personal_settings.analytics_consent.card_title')}
        </Card.Title>
        <Card.Description>
          {i18n.t('personal_settings.analytics_consent.card_description')}
        </Card.Description>
      </Card>
    </Section>
  )
}

export default observer(AnalyticsConsentSetting)
